import { FormWrapper } from 'components/formWrapper/formWrapper'
import { LoadingContainer } from 'components/loadingContainer'
import { useOrganizations } from 'hooks/admin/useOrganizations'
import { useShowById } from 'hooks/user/useShows/useShowById'
import React, { useEffect } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'

import { ShowForm } from './showForm'

export const ShowFormPage: React.FC = () => {
    const { id } = useParams<{ id?: string }>()
    const { data, isLoading, error } = useShowById(id || '')
    const navigate = useNavigate()

    const [searchParams] = useSearchParams()
    const partnerId = searchParams.get('partnerId') || undefined
    const { data: orgData } = useOrganizations()
    const partnerName = React.useMemo(() => orgData?.find((org) => org.org_id === partnerId)?.name, [partnerId, orgData])

    const handleClose = () => {
        if (partnerId) {
            const url = `/admin/musor/szervezet/${partnerId}`
            navigate(url)
        } else {
            navigate('/admin/musor')
        }
    }

    useEffect(() => {
        if (id && !data && !isLoading) navigate('/hiba/404')
    }, [id, data, isLoading, navigate])

    return (
        <FormWrapper onClose={handleClose} partnerName={partnerName}>
            <LoadingContainer isLoading={isLoading} error={error}>
                <ShowForm initialData={data} onClose={handleClose} partnerId={partnerId} />
            </LoadingContainer>
        </FormWrapper>
    )
}
